import React, { useCallback, useState } from "react";

import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Deal } from "@mapmycustomers/shared/types/entity";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import CreateDealModal from "@app/component/createEditEntity/CreateDealModal";
import ColumnFooterProps from "@app/component/DnDBoard/types/ColumnFooterProps";
import StageColumn from "@app/scene/deal/type/StageColumn";

import styles from "./ColumnFooter.module.scss";

interface Props extends ColumnFooterProps<StageColumn, Deal> {}

const ColumnFooter: React.FC<Props> = ({ analyticIssuer, column }) => {
  const intl = useIntl();
  const [stageToCreateDealFor, setStageToCreateDealFor] = useState<Stage | undefined>();
  const handleAddDeal = useCallback(() => {
    setStageToCreateDealFor(column.data.stage);
    analyticIssuer?.clicked(["Add Deal in Column"], column.name);
  }, [analyticIssuer, setStageToCreateDealFor, column]);

  return (
    <>
      <div className={styles.container} onClick={handleAddDeal}>
        <FontAwesomeIcon icon={faPlus} />
        {intl.formatMessage({
          id: "deal.kanbanView.addDeal",
          defaultMessage: "Add Deal",
          description: "Add Deal text on DND board",
        })}
      </div>
      {stageToCreateDealFor && (
        <CreateDealModal
          defaultFunnelId={stageToCreateDealFor?.funnel.id}
          defaultStageId={stageToCreateDealFor.id}
          onHide={() => setStageToCreateDealFor(undefined)}
        />
      )}
    </>
  );
};

export default ColumnFooter;
